module.exports = __webpack_public_path__ + "static/media/bestpassLogo.caaab9db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bestpassLogo.png
// module id = 1429
// module chunks = 0